import React from 'react';

const TimeInput24 = ({ value, onChange, required, className }) => {
  const hours = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  const minutes = Array.from({ length: 4 }, (_, i) => (i * 15).toString().padStart(2, '0'));

  const [hour, minute] = value ? value.split(':') : ['08', '00'];

  const handleHourChange = (e) => {
    const newHour = e.target.value;
    onChange(`${newHour}:${minute}`);
  };

  const handleMinuteChange = (e) => {
    const newMinute = e.target.value;
    onChange(`${hour}:${newMinute}`);
  };

  return (
    <div className="time-input-24-container">
      <select 
        className={`${className} time-select`}
        value={hour}
        onChange={handleHourChange}
        required={required}
      >
        {hours.map(h => (
          <option key={h} value={h}>{h}</option>
        ))}
      </select>
      <span className="time-separator">:</span>
      <select 
        className={`${className} time-select`}
        value={minute}
        onChange={handleMinuteChange}
        required={required}
      >
        {minutes.map(m => (
          <option key={m} value={m}>{m}</option>
        ))}
      </select>
    </div>
  );
};

export default TimeInput24;

